import React, { useState } from 'react';
import { SparklesIcon, PhoneIcon } from '@heroicons/react/24/outline';

const ContactPage: React.FC = () => {
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Ici vous pouvez ajouter la logique d'envoi du formulaire
    console.log('Form submitted:', formData);
    // Vous pourriez envoyer à votre API backend ou utiliser un service d'email
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative py-20 overflow-hidden">
        <img 
          src="/assets/images/bague-or-18-carats-diamants-aupiho-joaillerie.jpeg"
          alt="Bague en or 18 carats avec diamants - Aupiho Joaillerie"
          className="absolute inset-0 w-full h-full object-cover object-center"
          style={{ position: 'fixed' }}
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/70"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-light text-white mb-6 tracking-wide" style={{ fontFamily: 'MoonTime, cursive' }}>
              Contactez - nous
            </h1>
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="w-12 h-px bg-[#c69c70]"></div>
              <SparklesIcon className="h-8 w-8 text-[#c69c70]" />
              <div className="w-12 h-px bg-[#c69c70]"></div>
            </div>
            <p className="text-xl text-white/90 font-light max-w-2xl mx-auto">
              N'hésitez pas à nous contacter par email à{' '}
              <a href="mailto:hello@aupiho.com" className="text-[#c69c70] hover:text-[#b88a5f] underline">
                hello@aupiho.com
              </a>
              {' '}ou en remplissant le formulaire ci-dessous.
            </p>
            <p className="text-lg text-white/90 font-light mt-4">
              Nous vous répondrons dans les meilleurs délais (12h à 24h).
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0 max-w-6xl mx-auto shadow-2xl">
            {/* Image */}
            <div className="order-1 md:order-1">
              <div className="relative overflow-hidden h-full">
                <img 
                  src="/assets/images/contact/bagues-mains.jpg" 
                  alt="Contact Aupiho Joaillerie" 
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                
                {/* Contact Info Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                  <p className="text-base mb-3">
                    Nous sommes à votre écoute par <a href="mailto:hello@aupiho.com" className="underline hover:text-[#c69c70]">email</a>
                  </p>
                  <p className="text-sm mb-2">ou au</p>
                  <a 
                    href="tel:+33677267276" 
                    className="inline-flex items-center gap-2 text-white hover:text-[#c69c70] font-medium text-xl mb-3 transition-colors"
                  >
                    +(33)6 77 26 72 76
                  </a>
                  <p className="text-sm text-white/90">
                    (du lundi au vendredi 9h — 12h30 et 13h30 — 17h30)
                  </p>
                </div>
              </div>
            </div>

            {/* Form */}
            <div className="order-2 md:order-2 bg-[#c8a882] p-8 md:p-12">
              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Nom */}
                <div>
                  <label htmlFor="nom" className="block text-white font-medium mb-2">
                    Nom <span className="text-white/80">*</span>
                  </label>
                  <input
                    type="text"
                    id="nom"
                    name="nom"
                    value={formData.nom}
                    onChange={handleChange}
                    required
                    placeholder="Nom"
                    className="w-full px-4 py-3 border-2 border-white/30 focus:outline-none focus:border-white transition-colors bg-transparent text-white placeholder-white/60"
                  />
                </div>

                {/* Email */}
                <div>
                  <label htmlFor="email" className="block text-white font-medium mb-2">
                    Email <span className="text-white/80">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Email"
                    className="w-full px-4 py-3 border-2 border-white/30 focus:outline-none focus:border-white transition-colors bg-transparent text-white placeholder-white/60"
                  />
                </div>

                {/* Message */}
                <div>
                  <label htmlFor="message" className="block text-white font-medium mb-2">
                    Message <span className="text-white/80">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Message"
                    rows={6}
                    className="w-full px-4 py-3 border-2 border-white/30 focus:outline-none focus:border-white transition-colors resize-none bg-transparent text-white placeholder-white/60"
                  />
                </div>

                {/* Submit Button */}
                <div>
                  <button
                    type="submit"
                    className="w-full px-8 py-4 bg-white text-[#c8a882] hover:bg-white/90 transition-all duration-300 font-medium tracking-wider text-lg shadow-xl hover:shadow-2xl uppercase"
                  >
                    Envoyer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default ContactPage;

